import { useState, useEffect, useMemo, useCallback } from 'react';
import { apiClient } from '../../api_actions';
import LoadingOrbitalSpinner from '../LoadingOrbitalSpinner/LoadingOrbitalSpinner';

export const OfflineTrailersGridLogic = () => {
    const [deploymentsData, setDeploymentsData] = useState([]);
    const [loading, setLoading] = useState(false);

    const overlayComponentSelector = useCallback((params) => {
        if (params.overlayType === "loading") {
            return {
                component: LoadingOrbitalSpinner,
                params: {
                    loadingMessage: "Please wait while data is loading...",
                },
            };
        }
        // return undefined to use the provided overlay for other overlay types
        return undefined;
    }, []);

    const configureDeploymentsGrid = (data) => {
        const columnDefs = [
            {
                headerName: 'Tag',
                field: 'tagDisplay',
                flex: 1,
                valueGetter: (params) => {
                    const hardware = params.data.hardware_info?.tag || '';
                    const secondary = params.data.secondary_hardware_info?.tag || '';
                    return hardware && secondary ? `${hardware} | ${secondary}` : hardware || secondary;
                }
            },
            {
                headerName: 'Project',
                field: 'project.project_name',
                flex: 1,
            },
            {
                headerName: 'Location',
                field: 'location.name',
                flex: 1,
            },
            {
                headerName: 'Customer',
                field: 'project.customer.name',
                flex: 1,
            },
            {
                headerName: 'Owner',
                field: 'hardware_info.owner.owner_name',
                flex: 1,
            },
            {
                headerName: 'Time Offline',
                field: 'periscope_monitoring.downtime_total',
                flex: 1,
                valueGetter: (params) => {
                    const downtime = params.data.periscope_monitoring?.downtime_total || 0;
                    return `${(downtime / 3600).toFixed(2)} hrs`;
                }
            }
        ];

        return {
            columnDefs,
            rowData: data
        };
    };

    const gridConfig = useMemo(() => {
        return configureDeploymentsGrid(deploymentsData);
    }, [deploymentsData]);

    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

    const getDownDeployments = async () => {
        setLoading(true);
        try {
            const res = await apiClient.post(`read/deployments?online_status=true`);
            if (res && res.data) {
                setDeploymentsData(res.data);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getDownDeployments();
    }, []);

    return {
        // State
        gridConfig,
        containerStyle,
        gridStyle,
        loading,
        overlayComponentSelector,
    };
};
